import {createContext, useContext} from "react";

export const DrawContext = createContext();

export const useResult = () => useContext(DrawContext)